export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5133.c485df71.jpg";